<template>
  <div
    :class="{
      'activity': true,
      'activity_active': active
    }"
    @click.stop="$emit('clickCategory')"
    @dblclick.stop="$emit('editCategoryName')"
    @keydown.esc="$emit('reset')"
  >
    <div class="activity__item">
      <div
        v-if="changeName"
        class="activity__item-name"
        v-html="name"
      />
      <input
        v-if="!changeName"
        type="text"
        class="activity__item-name"
        :value="name"
        :readonly="changeName"
        @change="$emit('renameCategory',  $event)"
      />
      <DeleteCategoryIcon @delete="$emit('deleCategory')"/>
    </div>
  </div>
</template>

<script>
import DeleteCategoryIcon from '@/components/icons/DeleteCategoryIcon'
export default {
  name: 'CategoryItem',
  components: {
    DeleteCategoryIcon
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    changeName: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.activity {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  max-height: max-content;
  background-color: #00ABEC;
  border-radius: 4px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: 0.8s;
  outline:none;
  color: #FFFFFF;

  &__item {
    &-name {
      font-size: 16px;
      outline:none;
      border: none;
      transition: 0.8s;
      cursor: pointer;
      width: 100%;
      resize: none;
    }
    :deep(.close) {
      &::before, &::after {
        background-color: #FFFFFF;
      }
    }
  }

  &_active {
    background-color: #1F90BB;
    .activity__item, .activity__item-name {
      background-color: #1F90BB;
      color: #FFFFFF;
      transition: 0.8s;
    }

  }

  &:hover {
    background-color: #0080B0;
    .activity__item, .activity__item-name {
      background-color: #0080B0;
      color: #FFFFFF;
      transition: 0.8s;
    }
    :deep(.close) {
      transition: 0.8s;

      &::before, &::after {
        background-color: #FFFFFF;
        transition: 0.8s;
      }

      &:hover {
        background-color: #006084
      }
    }
  }

  &__item {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  &-title {
    font-size: 20px;
    color: #FFFFFF;
    transition: 0.8s;
  }
}
input, textarea {outline:none;}
input:active, textarea:active {outline:none;}
</style>
